/**
 * 基础商品数据
 */
import { makeAutoObservable, runInAction } from 'mobx'
import { restaurantConfig, discountMobx } from '@mobx/mall'
import { defaultConfig } from '@mobx/mall/cookware'
import { keyBy, cloneDeep } from '@dt/fe-utils/dist/lodash'
import { toDecimal } from '@dt/fe-utils'
import ProductAPI from 'api/mallProduct.api'

class Product {
  constructor () {
    makeAutoObservable(this)
  }
  /** 餐品默认图 */
  defaultPic = defaultConfig.defaultCover
  defaultPicDark = defaultConfig.defaultCoverDark

  channel: TChannel = 'mobile'
  /** 餐品数据 */
  products: IMallProduct[] = []
  /** 分类数据 */
  categories: ICategory[] = []
  brandId = Config.BRANDID
  isInited = false
  /** 全部类别餐品排序 */
  allProductSort: any[] = []

  /** 计算后的餐品数据集合, 能获取到餐品的售卖状态 显示情况等 */
  get viewProducts (): IMallViewProduct[] {
    // 这个是规格ID级的售卖数量，-1 0 >0 ,所有的规格都有这样的对应关系
    const productIdToIsCanTogo: any = {}
    const allProducts = this.products.map(product => {
      const scales: IScale[] = []
      // 当前的判断逻辑 显示最低价
      let isOpenPrice = false
      let minPrice = 99999999.99
      let theScaleNo = '0'
      let totalCnt = 0
      let saleCnt = 0
      let saleTotalCnt = 0 // 商品总数量
      product.scaleGroup.scales.forEach((scale) => {
        totalCnt += scale.cnt
        const vscale = cloneDeep(scale)
        vscale.saleCnt = scale.cnt
        vscale.saleTotalCnt = scale.cnt
        if (!saleCnt && scale.cnt > 0) {
          saleCnt = scale.cnt
        }
        saleTotalCnt += scale.cnt
        scales.push(vscale)
        if (scale.isOpenPrice) {
          isOpenPrice = true
          minPrice = -1
        } else if (typeof scale.price !== 'undefined') {
          if (scale.price <= minPrice) {
            minPrice = scale.price
            theScaleNo = scale.no
          }
        }
      })
      let offPrice = 0
      let actualPrice = minPrice
      let memberPrice = -1
      let isMemberDiscount = false
      if (discountMobx.itemDiscountMap && discountMobx.itemDiscountMap[product.no + '_' + theScaleNo]) {
        const offItem = discountMobx.itemDiscountMap[product.no + '_' + theScaleNo]
        offPrice = offItem.off
        actualPrice = toDecimal(minPrice - offPrice) as number
        isMemberDiscount = offItem.offType === 'memberPrice'
        // 如果该餐品享受了会员优惠则不用再显示会员价
        if (!isMemberDiscount) {
          memberPrice = offPrice > 0 ? -1 : (offItem.memberPrice || -1)
        }
      }
      // const isOpenPrice = product.scaleGroup.scales.some((scale) => scale.isOpenPrice)
      // 计算餐品的togo map
      productIdToIsCanTogo[product.id] = product.isCanTogo
      // 处理图片
      let pic = product.pic
      let picBig
      let picSmall
      let hasPic = false
      let picWidth
      let picHeight
      // if (restaurantConfig.app === 'mobile') {
      if (product.pic) {
        const defaultPicArr = JSON.parse(product.pics || '[]').filter((product: any) => product.default !== 0)
        const defaultPic = defaultPicArr.length ? defaultPicArr[0] : JSON.parse(product.pics || '[]')?.[0]
        // picWidth = product.picWidth
        // picHeight = product.picHeight
        picWidth = defaultPic.w
        picHeight = defaultPic.h
        if (defaultPic?.url && defaultPic?.type !== 'video') {
          pic = defaultPic?.url
        }
        const pics = pic?.split('.') || []
        // not support yet
        const base = pics[pics.length - 2]
        pics[pics.length - 2] = base + '_640'
        pic = pics.join('.')
        pics[pics.length - 2] = base + '_1280'
        picBig = pics.join('.')
        pics[pics.length - 2] = base + '_320'
        picSmall = pics.join('.')
        hasPic = true
      } else {
        // pic = this.defaultPic
        // picBig = product.pic
      }
      // }
      let viewProduct = {
        ...product,
        scales,
        price: minPrice,
        isCombo: false,
        disable: totalCnt === 0,
        isOpenPrice,
        scaleNo: theScaleNo,
        totalCnt,
        saleCnt,
        saleTotalCnt,
        offPrice,
        isMemberDiscount,
        actualPrice,
        memberPrice,
        hasPic,
        pic,
        picBig,
        picSmall,
        picWidth,
        picHeight,
        productGroups: undefined
      }
      return viewProduct
    })
    // 餐品
    const viewProducts = allProducts.filter(product => product.type === 'mallProduct')
    return [...viewProducts]
  }

  /** 餐品规格no的索引 */
  get noToViewProductScaleMap () {
    const productScaleMap: {
      [productScale: string]: {
        name: string;
        scaleName: string;
      };
    } = {}
    this.viewProducts.forEach(simpleProduct => {
      simpleProduct.scales.forEach(scale => {
        productScaleMap[simpleProduct.no + '_' + scale.no] = {
          name: simpleProduct.name,
          scaleName: simpleProduct.scales.length > 1 ? scale.name : ''
        }
      })
    })
    return productScaleMap
  }
  /** 餐品no(是否能单独售卖(套餐内餐品))的索引 */
  get noToIsNotSingleInComboViewProductMap () {
    return keyBy(this.viewProducts.filter((product: any) => product.isNotSingleInCombo), 'no') as {
      [no: string]: IMallViewProduct;
    }
  }
  /** 餐品no的索引 */
  get noToViewProductMap () {
    return keyBy(this.viewProducts, 'no') as {
      [no: string]: IMallViewProduct;
    }
  }
  /** 分类no的索引 */
  get categoryNoToCategoryMap () {
    return keyBy(this.categories, 'no') as {
      [categoryNo: string]: ICategory;
    }
  }
  /** 显示分类No对应的餐品 */
  get categoryNoToViewProductsMap () {
    const categroyMap: { [categoryNo: string]: IMallViewProduct[] } = {}
    this.viewProducts.forEach(viewProduct => {
      viewProduct.categories.forEach(categoryNo => {
        if (categroyMap[categoryNo]) {
          categroyMap[categoryNo].push(viewProduct)
        } else {
          categroyMap[categoryNo] = [viewProduct]
        }
      })
    })
    return categroyMap
  }

  /** 初始化置入餐品数据 */
  async init (channel?: TChannel) {
    const { products, categories } = await ProductAPI.getProduct(this.brandId)
    const allproductSort = await ProductAPI.getAllProducts()
    runInAction(() => {
      this.products = products as any[] || []
      this.allProductSort = allproductSort
      this.categories = categories || []
      this.channel = channel || (restaurantConfig.app === 'pos' ? 'pos' : 'mobile')
      this.isInited = true
    })
  }

  async getProducts () {
    return await ProductAPI.getProduct(this.brandId)
  }
  /** 重置餐品数据 */
  reset () {
    this.products = []
    this.categories = []
  }
}
export default new Product()
